export default __webpack_public_path__ + "images/CY.2f38dd9.png";